import api from "../../../api";


export function medicines(){
    return api.get("medicines");
}

export function deleteMedicines(id){
    return api.delete(`medicine/${id}`)
}

export function addMedicines(payload){
    return api.post("medicine", payload)
}